import { CloseOutlined } from "@mui/icons-material";
import {
	IconCheck,
	IconCubeSend,
	IconHourglassEmpty,
	IconShoppingCartCheck,
	IconTruckDelivery,
	IconTruckLoading,
} from "@tabler/icons-react";

// Shared config
const STATUS_TEMPLATES = {
	base: [
		{
			key: "order_received",
			label: "Order Received",
			filter: "Received",
			icon: IconShoppingCartCheck,
			animate_type: "popFade",
			completed: true,
			dynamic: (order) => ({
				changed_at: order.date_placed,
			}),
		},
		{
			key: "processing",
			label: "Processing",
			filter: "processing",
			icon: IconHourglassEmpty,
			animate_type: "spin",
			duration: "3s",
		},
	],
	cancelled: [
		{
			key: "cancelled",
			label: "Cancelled",
			filter: "cancelled",
			icon: CloseOutlined,
			color: "error",
			lines_exist: true,
		},
	],
	active: [
		{
			key: "confirmed",
			label: "Confirmed",
			filter: "confirmed",
			icon: IconCheck,
			animate_type: "popFade",
			lines_exist: true,
		},
		{
			key: "dispatched",
			label: "Dispatched",
			filter: "dispatched",
			icon: IconTruckLoading,
			animate_type: "moveX",
			lines_exist: true,
		},
		{
			key: "out_for_delivery",
			label: "Out for Delivery",
			filter: "out for delivery",
			icon: IconTruckDelivery,
			animate_type: "moveX",
			lines_exist: true,
		},
		{
			key: "order_delivered",
			label: "Order Delivered",
			filter: "order delivered",
			icon: IconCubeSend,
		},
	],
};

// For full order status history (includes lines metadata)
export const getOrderStatusHistorySteps = (order) => {
	const isCancelled = order.status?.toLowerCase() === "cancelled";
	const steps = [
		...STATUS_TEMPLATES.base,
		...(isCancelled ? STATUS_TEMPLATES.cancelled : STATUS_TEMPLATES.active),
	];

	return steps.map((step) => ({
		...step,
		...(step.dynamic ? step.dynamic(order) : {}),
		lines: [],
	}));
};

// For line-level status history (no "processing", no lines fields)
export const getLineStatusHistorySteps = (order) => {
	const isCancelled = order.status?.toLowerCase() === "cancelled";
	const steps = [
		...STATUS_TEMPLATES.base,
		...(isCancelled ? STATUS_TEMPLATES.cancelled : STATUS_TEMPLATES.active),
	]
		.filter((step) => step.key !== "processing")
		.map(({ lines_exist, ...step }) => ({
			...step,
			...(step.dynamic ? step.dynamic(order) : {}),
		}));

	return steps;
};
